function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#D8A28F"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5 10.9227H8.75C8.33333 10.9227 8 11.2345 8 11.6242V16.0762C8 16.4562 8.33333 16.7777 8.75 16.7777H13.5104C13.9166 16.7777 14.2604 16.4659 14.2604 16.0762V11.6242C14.25 11.2345 13.9166 10.9227 13.5 10.9227ZM13.625 16.0665C13.625 16.1249 13.5729 16.1737 13.5104 16.1737H8.75C8.6875 16.1737 8.63541 16.1249 8.63541 16.0665V11.6242C8.63541 11.5657 8.6875 11.517 8.75 11.517H13.5104C13.5729 11.517 13.625 11.5657 13.625 11.6242V16.0665Z",
  fill: "#2054D2"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16 8H11.25C10.8333 8 10.5 8.31174 10.5 8.70142V10.3381H11.125V8.70142C11.125 8.64297 11.1771 8.59426 11.2396 8.59426H16C16.0625 8.59426 16.1146 8.64297 16.1146 8.70142V13.1535C16.1146 13.212 16.0625 13.2607 16 13.2607H14.875V13.8452H16C16.4062 13.8452 16.75 13.5334 16.75 13.1438V8.70142C16.75 8.31174 16.4166 8 16 8Z",
  fill: "#2054D2"
});

function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.07ed59e7.svg";
export { ForwardRef as ReactComponent };